import { render, staticRenderFns } from "./goal-filter.vue?vue&type=template&id=cd80af0c&"
import script from "./goal-filter.vue?vue&type=script&lang=ts&"
export * from "./goal-filter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports